import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";

import teaser from "./images/teaser.png";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

// import MyCarousel from "./Carousel.js";

const Abstract = ({ mobile }) => (
  <div>
    

    <Image src={teaser} style={subsection_style}></Image>
    <p>
      <b></b> Image editing using a simple linear scaling with the 
      discovered universal editing directions on various facial style transformations.
    </p>
    <Header as="h2" textAlign="center" style={subsection_style}>
      Abstract
    </Header>
    <p>
      The disentanglement of StyleGAN latent space has paved the way for realistic and controllable image editing, 
      but does StyleGAN know anything about temporal motion, as it was only trained on static images? 
      To study the motion features in the latent space of StyleGAN, in this paper, we hypothesize and demonstrate that 
      a series of meaningful, natural, and versatile small, local movements (referred to as "micromotion", such as 
      expression, head movement, and aging effect) can be represented in low-rank spaces extracted from the latent space 
      of a conventionally pre-trained StyleGAN-v2 model for face generation, with the guidance of proper "anchors" 
      in the form of either short text or video clips. Starting from one target face image, with the editing direction 
      decoded from the low-rank space, its micromotion features can be represented as simple as an affine transformation 
      over its latent feature. Perhaps more surprisingly, such micromotion subspace, even learned from just single target face, 
      can be painlessly transferred to other unseen face images, even those from vastly different domains 
      (such as oil painting, cartoon, and sculpture faces). It demonstrates that the local feature geometry corresponding to 
      one type of micromotion is aligned across different face subjects, and hence that StyleGAN-v2 is indeed "secretly" aware 
      of the subject-disentangled feature variations caused by that micromotion. We present various successful examples of 
      applying our low-dimensional micromotion subspace technique to directly and effortlessly manipulate faces, 
      showing high robustness, low computational overhead, and impressive domain transferability.
    </p>
  </div>
);

export default Abstract;
